import styled from "styled-components";
import { Paper, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const Wrapper = styled(Paper)`
  padding: 4px;
  border-radius: 0px;
  background: linear-gradient(74.08deg, #f16ea4 -15.53%, #f9e4a4 85.93%);
`;

const GridContainer = styled(Grid)`
  height: 100%;
  display: inline-block;
`;

const WelcomeTypo = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  color: #fff;
  padding-inline-start: 35px;
  position: relative;
  bottom: -5px;
`;

const Typo = styled(Typography)`
  font-size: 27px;
  font-weight: 500;
  text-align: left;
  color: #fff;
  padding-inline-start: 35px;
`;

export default function GradientNavbar() {
  const { dashboardState } = useSelector((state) => state.memberDetails);

  return (
    <Wrapper elevation={2}>
      <GridContainer container>
        <WelcomeTypo>Welcome back to</WelcomeTypo>
        <Typo>
          {dashboardState === "promotion"
            ? "Smart Exchange"
            : "Smart Digital Advertising"}
        </Typo>
      </GridContainer>
    </Wrapper>
  );
}
